export const tooltipOverlayStyle = {
  pointerEvents: "none",
};
